var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-service space-50",staticStyle:{"padding-top":"100px"}},[_c('UiHeading',{attrs:{"h":'2',"type":'E',"text":'Contact',"subTitle":'お問い合わせ',"id":"contact"}}),_c('ContactContactForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }